import { useContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { SmartContext } from '../../../library/Core/SmartContext';
import { ControlOnChangeArguments } from '../../../library/Core/SmartTypes';
import WidgetConfigurationLayout from '../WidgetConfigurationLayout';
import PageBuilder from '../../../library/Builders/PageBuilder/PageBuilder';
import { getAssociativeArray, isEmpty, triggerGridDataOnChange } from '../../../library/Core/SmartFunctions';

const CurrentLocationCountry = () => {
    const { state, dispatch } = useContext(SmartContext);
    let {id, code} = useParams();

    const isEditing = !!id;
    if ( typeof code == 'undefined') {
        code = '';
    }
    
    useEffect(() => {
        dispatch({ type: 'ADD_ACTIONS', payload: { ...state.actions, metricEntity: onInputChange, value: onInputChange, metricType: onInputChange } });
    }, []);

    useEffect(() => {
        if ( isEditing ) {
            return;
        }

        const allowedWidgets = ['current_location_country']

        if (!code || !state?.internal?.[code] || !allowedWidgets.includes(code)) {
            return;
        }

        const metricData = state?.data?.metricData;

        if (!Array.isArray(metricData)) {
            console.error('metricData is not an array', metricData);
            return;
        }

        const fetchedData = state.internal[code].filter((rec: any) => String(rec?.metricEntityCode) !== '0');
        const updatedMetricData = fetchedData.slice(0, 4).map((rec: any, idx: number) => ({
            ...(metricData[idx] || {}),
            id: idx,
            metricEntity: rec?.metricEntityCode
        }));

        dispatch({
            type: 'REFRESH_DATA',
            payload: {
                data: {...state.data, metricData: updatedMetricData}
            },
        });

        setTimeout(() => {
            triggerGridDataOnChange(updatedMetricData, "metricData", "metricEntity");
        }, 500);

    }, [state.internal.current_location_country])

    function onInputChange(props: ControlOnChangeArguments) {
        if ( isEmpty(props.state.internal) ) {
            return false;
        }

        // Bail out if parent row doesn't exist in state — prevents
        // "Cannot set properties of undefined (setting 'value')" when
        // triggerGridDataOnChange synthesizes events on rows missing from state.data.metricData.
        if (!props.parentDataKey || isEmpty(props.row)) {
            return;
        }

        let metricEntity = props?.value;
        let value = (!isNaN(props?.value)  && props?.value > 0) ? props?.value : 0;
        let metricType= props?.value;
        
        if (props.control.id != 'metricType') {
            metricType = props?.row?.metricType;
        }

        if (props.control.id != 'value') {
            value = props?.row?.value;   
        }
        
        if (props.control.id != 'metricEntity') {
            metricEntity = props?.row?.metricEntity;   
        }

        if (!code || !props?.state?.internal[code]) {
            return;
        }

        const errorMessages = [] as any[];
        let countData = getAssociativeArray(props.state?.internal?.[props.state?.internal?.widget_code], 'metricEntityCode');
        const totalAlumniCount = props.state?.internal?.[code].reduce((sum: any, item: any) => sum + item.userCount, 0);

        let currentCareerUserCount = countData[metricEntity]?.userCount ?? 0;
        let currentPercentage: any = 0;
        let totalPercentage: any = 0;
        
        currentPercentage = Math.round((currentCareerUserCount/totalAlumniCount)*100)

        if (metricType == 'override') {
            currentPercentage = (!isNaN(value)  && value > 0) ? value : 0;
        }

        currentPercentage = parseFloat(currentPercentage);

        props.state.data?.metricData?.map((data: any) => {
            if ( ! isEmpty(data?.metricEntity) && ! isEmpty(data?.value) && data?.metricEntity != metricEntity ) {
                totalPercentage += parseFloat(data.value);
            }
        })

        props.dispatch({
            type: 'CONTROL_VALUE_CHANGE',
            payload: {
                dataKey: `${props.parentDataKey}.value`,
                value: currentPercentage,
            },
        });

        totalPercentage += currentPercentage;
        let remainingValue: any = 100-parseFloat(totalPercentage); // calculating other career percentage;
        let remainingValueDisp = remainingValue%1 == 0 ? remainingValue.toFixed(0) : remainingValue.toFixed(2); // calculating other career percentage;

        props.dispatch({
            type: 'CONTROL_VALUE_CHANGE',
            payload: {
                dataKey: `widgetData.other`,
                value:  remainingValueDisp
            },
        });
    };
    
    return (
        <WidgetConfigurationLayout state={state} >{!state.flags.isDataLoading && <PageBuilder />}</WidgetConfigurationLayout>
    );
};

export default CurrentLocationCountry;